<div class="form-body">
    <form class="legacy" autocomplete="off" [formGroup]="createForm" (ngSubmit)="onCreate(createForm?.value)">
      <div>
        <label>Name: </label>
        <input type="text" formControlName="name" autocomplete="off">
      </div>      
      <button class="legacy" type="submit">Submit</button>
    </form>
  </div>